module.exports = __webpack_public_path__ + "img/57.problem_soap_dispenser.fa55222f.svg";